import React from "react";
import { Reveal } from "@/components/Motion";
import { brand } from "@/config/site";

export default function Privacy() {
  return (
    <section data-testid="privacy-page" className="min-h-screen bg-dh-bg pt-36 pb-28 sm:pt-48 sm:pb-36">
      <div className="mx-auto max-w-[760px] px-5 sm:px-8">
        <Reveal>
          <p className="font-body text-[11px] uppercase tracking-ultra text-dh-gold">Privacy</p>
          <h1 className="mt-6 font-display text-4xl text-dh-cream sm:text-6xl">Privacy</h1>
        </Reveal>

        <div className="mt-12 space-y-6 font-body text-base leading-relaxed text-dh-cream/75">
          <Reveal>
            <p>
              Dhamma Publishing House respects the trust you place in us when you share your information. This page
              explains, plainly, how we handle it.
            </p>
          </Reveal>
          <Reveal>
            <div>
              <h2 className="font-display text-2xl text-dh-cream">What we collect</h2>
              <p className="mt-3">
                When you join our community or reach out through our contact form, we collect the name and email address
                you provide, along with any message you choose to send. We do not collect payment information on this
                site.
              </p>
            </div>
          </Reveal>
          <Reveal>
            <div>
              <h2 className="font-display text-2xl text-dh-cream">How we use it</h2>
              <p className="mt-3">
                We use your information to respond to your inquiries and to share reveals, releases, and reader
                opportunities from Dhamma. We do not sell your information. You can ask to be removed at any time by
                emailing{" "}
                <a href={`mailto:${brand.contactEmail}`} className="text-dh-gold hover:underline">
                  {brand.contactEmail}
                </a>
                .
              </p>
            </div>
          </Reveal>
          <Reveal>
            <div>
              <h2 className="font-display text-2xl text-dh-cream">Questions</h2>
              <p className="mt-3">
                For any privacy question, reach us at{" "}
                <a href={`mailto:${brand.contactEmail}`} className="text-dh-gold hover:underline">
                  {brand.contactEmail}
                </a>
                . Response times may vary.
              </p>
            </div>
          </Reveal>
        </div>

        <div className="gold-rule my-12" />
        <p className="font-body text-xs text-dh-muted">{brand.copyright}</p>
      </div>
    </section>
  );
}
